/* istanbul ignore file */
import { boolean as codecBoolean } from 'purify-ts/Codec';
import { utils as coreUtils } from '@codegrade/api-core';
import { parsers } from '@codegrade/utils';
const Lti1p3NonceAndStateValidationEnabledSettingParser = 
/* #__PURE__ */ parsers.object([
    [
        'name',
        /* #__PURE__ */ parsers.exactly('LTI_1P3_NONCE_AND_STATE_VALIDATION_ENABLED'),
    ],
    ['value', /* #__PURE__ */ parsers.maybeNull(codecBoolean)],
]);
export class Lti1p3NonceAndStateValidationEnabledSetting extends /* #__PURE__ */ coreUtils.AssigningBase {
    static decode(input) {
        return Lti1p3NonceAndStateValidationEnabledSettingParser.decode(input).map(res => new Lti1p3NonceAndStateValidationEnabledSetting(res));
    }
    static unsafeDecode(input) {
        return Lti1p3NonceAndStateValidationEnabledSetting.decode(input).unsafeCoerce();
    }
    static encode(data) {
        return Lti1p3NonceAndStateValidationEnabledSettingParser.encode(data);
    }
    static schema() {
        return Lti1p3NonceAndStateValidationEnabledSettingParser.schema();
    }
}
